import { FC, useState } from 'react';
import { Button } from 'react-daisyui';

type RejectCarerModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  carerName: string;
  isLoading?: boolean;
};

const RejectCarerModal: FC<RejectCarerModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  carerName: _carerName,
  isLoading = false,
}) => {
  const [reason, setReason] = useState('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm(reason);
    setReason('');
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 p-6">
        <h2 className="text-xl font-bold mb-4">Why are you rejecting the application?</h2>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Type here..."
          className="w-full h-32 p-3 border border-gray-300 rounded-lg resize-none focus:outline-none focus:border-black"
        />
        <div className="flex gap-3 justify-end mt-4">
          <Button
            onClick={handleClose}
            disabled={isLoading}
            className="bg-white text-black border border-gray-300 hover:bg-gray-50 rounded-lg"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={isLoading || !reason.trim()}
            className="bg-[#FF5861] text-white border-none hover:opacity-80 rounded-lg disabled:opacity-50"
          >
            {isLoading ? 'Rejecting...' : 'Reject'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RejectCarerModal;
